import { InternalTaskIndex } from "../../model/InternalTaskIndex";
import { InternalTaskViewModel } from "../../model/InternalTaskViewModel";
import { ApiResponse } from "../CustomFetch";
import { api } from "./BaseApi";

const getInternalTaskUrl = (id?: string) => "/InternalTask" + (id === undefined ? "" : `/${id}`);

const internalTasksApi = api.enhanceEndpoints({ addTagTypes: ["InternalTasks"] }).injectEndpoints({
  endpoints: (builder) => ({
    getInternalTasks: builder.query<InternalTaskIndex[], void>({
      query: () => getInternalTaskUrl(),
      transformResponse: (response: ApiResponse<InternalTaskIndex[]>) => response.data,
      providesTags: [{ type: "InternalTasks", id: "LIST" }],
    }),
    getInternalTask: builder.query<InternalTaskViewModel, string>({
      query: getInternalTaskUrl,
      transformResponse: (response: ApiResponse<InternalTaskViewModel>) => response.data,
      providesTags: (_result, _error, arg) => [{ type: "InternalTasks", id: arg }],
    }),
    updateInternalTask: builder.mutation<ApiResponse<void>, InternalTaskViewModel>({
      query: (internalTask: InternalTaskViewModel) => ({
        url: getInternalTaskUrl(),
        body: internalTask,
        headers: { "Content-Type": "application/json" },
        method: "PUT",
      }),
      invalidatesTags: (_result, _error, arg) => [
        { type: "InternalTasks", id: "LIST" },
        { type: "InternalTasks", id: arg.id },
      ],
    }),
  }),
});

export const { endpoints, useGetInternalTasksQuery, useGetInternalTaskQuery, useUpdateInternalTaskMutation } =
  internalTasksApi;
